import React from 'react'

export const AChatUserInitials = ({ initials }) => (
  <div className="flex justify-center items-center flex-shrink-0 w-7 h-7 text-gray-700 bg-gray-50 drop-shadow-avatar rounded-full">
    <p className="text-sm lg:text-base">{initials}</p>
  </div>
)
